// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".BreadCrumbs{display:flex;justify-content:flex-start;align-items:center;width:100%;padding:20px 0;border-top:1px solid #ececec}.BreadCrumbs .obflink,.BreadCrumbs a{text-decoration:none;color:#969696}.BreadCrumbs .obflink:hover,.BreadCrumbs a:hover{text-decoration:underline}.BreadCrumbs .obflink :last-child,.BreadCrumbs a :last-child{color:#224960}.BreadCrumbs .obflink{display:inline}.BreadCrumbs span{margin:5px;color:#969696}.BreadCrumbs strong{font-weight:400}", ""]);
// Exports
module.exports = exports;
